import { AccountNetworkOutlineIcon } from './AccountNetworkOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 2EEA7799-E0DA-4E9B-880E-B5975A6FC11F
 * name account-network-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-network-outline.svg
 * tags
 * - Account / User 
 */
export const PersonNetworkOutlineIcon = AccountNetworkOutlineIcon;
export default PersonNetworkOutlineIcon